import { DynamicPointSymbol } from "@evergis/sgis/es/symbols/Symbol";
import React from "react";
import ReactDOM from "react-dom";
import { LabelFeature } from "@evergis/sgis/es/features/Label";
import { Offset } from "@evergis/sgis/es/baseTypes";

type ReactLabelSymbolParams = {
  offset?: Offset;
  component?: React.ComponentType<{ content: string }>;
};

export class ReactLabelSymbol extends DynamicPointSymbol {
  public component?: React.ComponentType<{ content: string }>;

  constructor({ component, offset }: ReactLabelSymbolParams = {}) {
    super({ offset });
    this.component = component;
  }

  protected _getFeatureNode(feature: LabelFeature): HTMLElement {
    const node = document.createElement("div");

    this.renderDom(feature.content, node);

    return node;
  }

  protected _updateFeatureNode(feature: LabelFeature) {
    this.renderDom(feature.content, this.getNode(feature));
  }

  private renderDom(content: string, node: HTMLElement) {
    if (!node) {
      return;
    }

    const Component = this.component;

    if (Component) {
      ReactDOM.render(<Component content={content} />, node);
    } else {
      node.innerText = content;
    }
  }
}
